import GeneralConfirmModal from 'components/general-confirm-modal';
import { useTranslation } from 'react-i18next';
import { CONTRACT_COMPLIANCE__CONFIRM_SAVE, CONTRACT_COMPLIANCE__REMOVE_DISCLAIMER } from 'translations/constants';
import { UseRuleExceptionPanelResult } from './hooks/useRuleExceptionPanel';
import { getScopeEntityLabel } from './utils';

interface ConfirmablePanel {
  isConfirmOpen: boolean;
  isSaving: boolean;
  cancelConfirm: () => void;
  confirmSave: () => void;
}

interface PanelConfirmModalsProps {
  defaultPanel: ConfirmablePanel;
  exceptionPanel: UseRuleExceptionPanelResult;
  testIdPrefix: string;
}

const PanelConfirmModals = ({ defaultPanel, exceptionPanel, testIdPrefix }: PanelConfirmModalsProps): JSX.Element => {
  const [t] = useTranslation();
  const confirmingPanel: ConfirmablePanel = defaultPanel.isConfirmOpen ? defaultPanel : exceptionPanel;

  return (
    <>
      <GeneralConfirmModal
        open={defaultPanel.isConfirmOpen || exceptionPanel.isConfirmOpen}
        onClose={confirmingPanel.cancelConfirm}
        onAction={confirmingPanel.confirmSave}
        content={t(CONTRACT_COMPLIANCE__CONFIRM_SAVE)}
        confirmTestId={`${testIdPrefix}-confirm-save`}
        cancelTestId={`${testIdPrefix}-confirm-cancel`}
        actionDisabled={confirmingPanel.isSaving}
      />
      <GeneralConfirmModal
        open={exceptionPanel.isRemoveOpen}
        onClose={exceptionPanel.cancelRemove}
        onAction={exceptionPanel.confirmRemove}
        content={t(CONTRACT_COMPLIANCE__REMOVE_DISCLAIMER, {
          entity: exceptionPanel.exception ? getScopeEntityLabel(t, exceptionPanel.exception) : '',
        })}
        confirmTestId={`${testIdPrefix}-remove-confirm`}
        cancelTestId={`${testIdPrefix}-remove-cancel`}
        actionDisabled={exceptionPanel.isSaving}
      />
    </>
  );
};

export default PanelConfirmModals;
